import { render, staticRenderFns } from "./ruta-naturaleza.vue?vue&type=template&id=5446c3a8&"
import script from "./ruta-naturaleza.vue?vue&type=script&lang=js&"
export * from "./ruta-naturaleza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports